module.exports = __webpack_public_path__ + "img/facebook.fde73d2d.svg";